import { gql } from '@apollo/client';

export const ProductListFragment = gql`
  fragment ProductListFragment on Cart {
    id
    items {
      uid
      robes_gifts_customization {
        label
        value
      }
      select_product_image
      cart_item_stock_status
      weboSku
      available_product {
        sku
        uid
        id
        url_key
      }
      product {
        __typename
        uid
        shipping_type
        is_try_on
        name
        sku
        url_key
        price {
          regularPrice {
            amount {
              currency
              value
            }
          }
        }
      }
      prices {
        price {
          currency
          value
        }
      }
      quantity
      ... on ConfigurableCartItem {
        configurable_options {
          id
          configurable_product_option_uid
          option_label
          configurable_product_option_value_uid
          value_label
          option_default_label
          value_default_label
          __typename
        }
      }
      select_options {
        option_id
        option_value_id
        option_label
        value_label
        option_default_label
        value_default_label
      }
      custom_info {
        label
        value
      }
    }
  }
`;
